import React from "react";
import axios from "axios";
import { Component } from "react";
import ReactModal from "react-modal";
import SglContext from "../SglContext";
import AddBankAccount from "./addBankAccount";
var AddModal = ReactModal;

/* ManageCards Component 
-------------------------------------------------*/
class AddBankModal extends React.Component {
    constructor(props) {
        super(props);

        this.closeAddBankModal = this.closeAddBankModal.bind(this);
        
        this.state = {  
        };
    }

    componentWillMount() {
        
    }  

    closeAddBankModal() {
        this.props.closeAddBankModal()
    }

    render() {
        
        return (
            <div>
                <AddModal
                    isOpen={this.props.is_open_add_bank_modal}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeAddBankModal}
                    className="mymodal modal-width-responsive manage-cards"
                    overlayClassName="myoverlay"
                    ariaHideApp={false}
                >
                    <h2>Add Bank Account</h2>    
                    <AddBankAccount insideModal={true} key={Date.now()} />
                    <div class='continue-button-div'>
                        <div style={{clear: "both"}}></div>
                        <button class='right' onClick={this.closeAddBankModal}>
                        Close
                        </button>
                    </div>
                </AddModal>
            </div>      
        );
    }
}
AddBankModal.contextType = SglContext

export default AddBankModal;